/**
 * @generated SignedSource<<18d29997ecbdefc9f0e66fb1051e6687>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactHasActiveEventRequestInlineFragment$data = {
  readonly hasActiveEventRequest: boolean | null;
  readonly " $fragmentType": "contactHasActiveEventRequestInlineFragment";
};
export type contactHasActiveEventRequestInlineFragment$key = {
  readonly " $data"?: contactHasActiveEventRequestInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactHasActiveEventRequestInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactHasActiveEventRequestInlineFragment"
};

(node as any).hash = "79b5605c33299c469eaaad5352080a68";

export default node;
